// TODO: config name for dynamic loaders
export { WithHighlight } from './with-highlight'
export { WithEditor } from './with-editor'
